// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2l18o","list":"BalanceDue_list__15trI","listRow":"BalanceDue_listRow__1KGxU","total":"BalanceDue_total__3419K"};